import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { BaseModal } from 'src/app/core/utils/BaseModal';
import { ModalContent } from 'src/app/core/interface';
import {
  AlertService, CompanyService, RegionService,
  ContractService, ModalService, FileTemplateService,
  RegulationService, StorageService,
  StorageKey, UserGroupService, UserService
} from 'src/app/core/services';
import { Contract, FileTemplate, Regulation, Region, Company, AlertItem, AlertType, User, MessageModal } from 'src/app/core/models';
import moment from 'moment-timezone';
import { updateCurrentContracts, updateLocalStorage } from 'src/app/core/utils/updateLocalStorage';
import { Gb } from 'src/app/core/services/growthbook.service';

// eslint-disable-next-line no-shadow
export enum ContractStatus {
  Active = 'enabled',
  Closed = 'closed',
  Test = 'test',
  History = 'history',
  Expired = 'expired'
}

export const ModulesBequest = [
  { id: 'central', name: 'Central', selected: false },
  { id: 'appraisal', name: 'Aferição', selected: false },
  { id: 'gerincid', name: 'Gerincid', selected: false },
  { id: 'imageCenter', name: 'Image-center', selected: false },
  { id: 'violation', name: 'Infração', selected: false },
  { id: 'jammer', name: 'Jammer', selected: false },
  { id: 'monitoring', name: 'Monitoramento', selected: false },
  { id: 'route', name: 'Percurso', selected: false },
  { id: 'rap', name: 'RAP', selected: false },
  { id: 'sgs', name: 'SGS', selected: false },
  { id: 'flow', name: 'Fluxo', selected: false },
  { id: 'status', name: 'Status', selected: false }
];

@Component({
  selector: 'app-contract-create-or-update',
  templateUrl: './contract-create-or-update.component.html',
  styleUrls: ['./contract-create-or-update.component.sass']
})
export class ContractCreateOrUpdateComponent extends BaseModal implements OnInit, ModalContent {
  @Input() initialState;

  public isValid = false;
  public contract: Contract = new Contract();
  public promise: Promise<any>;
  public loading = true;
  public typeUnfoldLimit = 'less';
  public typeUnfoldSpeed = 'less';
  public typeUnfoldTemplate = 'less';
  public typeUnfoldAdditional = 'less';
  public companies: Array<Company>;
  public selectedCompanies: Array<Company>;
  public contracts: Array<Contract>;
  public regions: Array<Region>;
  public regulations: Array<Regulation>;
  public filetemplates: Array<FileTemplate>;
  public contractForm: FormGroup;
  public contractId: any;
  public extraDataArray = [];
  public speedCalculationArray = [];
  public aitTemplatesArray = [];
  public checkBoxes = true;
  public enabledContractNumber = false;
  public speed = false;
  public user: User = new User();
  public gb: Gb;
  public moduleArray = [
    'preProcess',
    'violations',
    'traffic',
    'status',
    'monitoring'
  ];
  public ownerCompanyActive = false;

  public ecsModules = {
    open: false
  };

  public legacyModules = {
    open: false
  };

  public disabledLegacycheckBoxes = true;

  public modulesBequest = ModulesBequest;

  public contractStatusType = ContractStatus;
  public contractStatus = ContractStatus.Active;

  private dateValues = {
    endHour: null,
    endsAt: null,
    startsAt: null,
    startHour: null
  };

  constructor(
    private formBuilder: FormBuilder,
    public storageService: StorageService,
    public modalService: ModalService,
    public contractService: ContractService,
    public regulationService: RegulationService,
    private alertService: AlertService,
    private companyService: CompanyService,
    private regionService: RegionService,
    private fileTemplateService: FileTemplateService,
    private userGroupService: UserGroupService,
    private userService: UserService,
  ) {
    super(modalService);
    this.gb = new Gb();
  }

  async ngOnInit() {
    this.contract = this.initialState as Contract || new Contract();
    if (this.contract?.status) {
      this.contractStatus = this.contract?.status as ContractStatus;
    }
    if (this.contract?.id) {
      this.enabledContractNumber = true;
    }
    const user = this.storageService.get(StorageKey.currentUser);
    if (user != null) {
      this.user = user;
    }
    this.createForm();
    await this.getSelects();
    if (this.contract?.id && this.contractForm.get('companyIds').value.length > 0) {
      this.ownerCompanyActive = true;
    }
    if (this.contractForm.get('code').value !== null) {
      this.loading = true;
      setTimeout(() => {
        this.contractForm.get('code').patchValue(this.contractForm.get('code').value);
      }, 2000);
    }
    this.setSelectedCompanies();
    this.setEditModulesBequest();
    await this.gb.init();
  }

  setContractStatus(status: ContractStatus) {
    this.contractStatus = status;
  }

  setEditModulesBequest() {
    try {
      if (this.contract.modulesBequest) {
        for (const module of this.contract.modulesBequest) {
          this.modulesBequest.find(a => a.id === module).selected = true;
        }
      }
    } catch (error) {
      console.warn(error);
    }
  }

  async getSelects() {
    await this.companyService.getAll().then(list => {
      this.companies = list;
    });
    await this.regionService.getAll().then(list => {
      this.regions = list;
    });
    await this.contractService.getAll(null, true).then(list => {
      this.contracts = list;
    });
    const params = { contractId: this.contract.id };
    this.fileTemplateService.list(params).then(list => {
      this.filetemplates = list.result;
    });
  }

  createForm(): void {
    const enabledObj: any = {
      omnia: this.contract.enabled?.omnia ? this.contract.enabled.omnia : false,
      initus: this.contract.enabled?.initus ? this.contract.enabled.initus : false,
      initusTraffic: this.contract.enabled?.initusTraffic ? this.contract.enabled.initusTraffic : false,
      ecs: this.contract?.enabled?.ecs ? this.contract?.enabled?.ecs : false,
      bequest: this.contract.enabled?.bequest ? this.contract.enabled.bequest : false,
      modulesBequest: this.contract.modulesBequest || []
    };
    this.checkBoxes = !enabledObj?.ecs;
    this.disabledLegacycheckBoxes = !enabledObj?.bequest;
    const moduleObj = {
      preProcess: this.contract?.modules ? this.contract.modules.includes('preProcess') : false,
      violations: this.contract?.modules ? this.contract.modules.includes('violations') : false,
      traffic: this.contract?.modules ? this.contract.modules.includes('traffic') : false,
      status: this.contract?.modules ? this.contract.modules.includes('status') : false,
      monitoring: this.contract?.modules ? this.contract.modules.includes('monitoring') : false
    };
    const starts = this.contract.startsAt;
    const ends = this.contract.endsAt;
    const startsAt = starts && moment(starts).format('YYYY-MM-DD');
    const startHour = starts && moment(starts).format('HH:mm:ss');
    const endsAt = ends && moment(ends).format('YYYY-MM-DD');
    const endHour = ends && moment(ends).format('HH:mm:ss');
    const hourRegex = new RegExp(/^(([0-1][0-9])|(2[0-3])):[0-5][0-9]:[0-5][0-9]$/);

    this.contractForm = this.formBuilder.group({
      code: [this.contract?.code || '', [Validators.required]],
      internalCode: [
        this.contract?.internalCode || '', [
          Validators.maxLength(10),
          Validators.pattern(/^[A-Za-z0-9\-\/\.]*$/)],
      ],
      name: [this.contract?.name || '', [Validators.required]],
      ownerCompanyId: [this.contract?.ownerCompanyId || '', [Validators.required]],
      companyIds: [this.contract?.companyIds || '', [Validators.required]],
      regionId: [this.contract?.regionId || 1, [Validators.required]],
      startsAt: [startsAt || '', [Validators.required, this.validateDate]],
      endsAt: [endsAt || '', [Validators.required, this.validateDate]],
      startHour: [startHour || '00:00:00', [Validators.required, Validators.pattern(hourRegex), this.validateDate]],
      endHour: [endHour || '23:59:59', [Validators.pattern(hourRegex), this.validateDate]],
      omnia: [enabledObj.omnia],
      initus: [enabledObj.initus],
      initusTraffic: [enabledObj.initusTraffic],
      ecs: [enabledObj?.ecs || false],
      bequest: [enabledObj.bequest],
      preProcess: [moduleObj.preProcess],
      violations: [moduleObj.violations],
      traffic: [moduleObj.traffic],
      status: [moduleObj.status],
      monitoring: [moduleObj.monitoring],
      equipments: [this.contract.limits?.equipments || '',],
      spots: [this.contract.limits?.spots || '',],
      lanes: [this.contract.limits?.lanes || '',],
      speedCalculations: new FormBuilder().array([]),
      aitTemplates: new FormBuilder().array([]),
      extraData: new FormBuilder().array([]),
      bequestUrl: [this.contract?.bequestUrl || '']
    });
    this.contractForm.valueChanges.subscribe(() => {
      this.isValid = this.contractForm.valid;
    });
    this.contractForm.get('companyIds').valueChanges.subscribe(value => {
      if (value.length > 0) {
        this.ownerCompanyActive = true;
      } else {
        this.ownerCompanyActive = false;
      }
      this.setSelectedCompanies();
    });
    if (!this.contract.id) {
      const items = [
        {
          regulationId: 74550,
          initialSpeedFormula: 'round(v + 1)',
          finalSpeedFormula: 'round(v * 1.2)'
        },
        {
          regulationId: 74630,
          initialSpeedFormula: 'round(v * 1.2 + 1)',
          finalSpeedFormula: 'round(v * 1.5)'
        },
        {
          regulationId: 74710,
          initialSpeedFormula: 'round(v * 1.5 + 1)',
          finalSpeedFormula: ''
        }
      ];
      for (const item of items) {
        this.addSpeedCalculations(item);
      }
      this.addExtraData('');
      this.addAitTemplates();
      this.getRegulation(1);
    } else {
      this.getRegulation(this.contract?.regionId);
      if (this.contract.extraData !== undefined && this.contract?.extraData?.length > 0) {
        for (const extraData of this.contract.extraData) {
          this.addExtraData(extraData);
        }
      }
      if (this.contract?.speedCalculations !== undefined && this.contract?.speedCalculations?.length > 0) {
        for (const item of this.contract.speedCalculations) {
          this.addSpeedCalculations(item);
        }
      }
      if (this.contract?.aitTemplates !== undefined && this.contract?.aitTemplates?.length > 0) {
        for (const item of this.contract.aitTemplates) {
          this.addAitTemplates(item);
        }
      }
    }
  }

  setSelectedCompanies() {
    this.selectedCompanies = [];
    const companyIds: string[] = this.contractForm.get('companyIds').value || [];
    for (const itemId of companyIds) {
      if (!this.selectedCompanies.find(a => a.id === itemId) && this.companies.find(a => a.id === itemId)) {
        this.selectedCompanies.push(this.companies.find(a => a.id === itemId));
      }
    }
  }

  get lastState(): any {
    throw new Error('Method not implemented.');
  }

  emitValid(value) {
    const event = new CustomEvent('contractSaved', { detail: value });
    document.dispatchEvent(event);
  }

  validateDate = () => {
    if (this.contractForm == null) {
      return null;
    }
    const dateControls: any = {};
    const newDateValues = {};
    let hasChange = false;
    for (const key of Object.keys(this.dateValues)) {
      dateControls[key] = this.contractForm.get(key);
      newDateValues[key] = dateControls[key].value;
      if (newDateValues[key] !== this.dateValues[key]) {
        hasChange = true;
      }
    }
    this.dateValues = Object.assign(newDateValues);
    if (hasChange) {
      for (const key of Object.keys(dateControls)) {
        dateControls[key].updateValueAndValidity();
      }
    }
    const endsAt = dateControls.endsAt.value + dateControls.endHour.value;
    const startsAt = dateControls.startsAt.value + dateControls.startHour.value;
    if (endsAt && endsAt <= startsAt) {
      return {
        invalidPeriod: 'Fields startHour greater than endHour'
      };
    } if (!moment(startsAt).isValid) {
      return {
        invalidPeriod: 'Fields startHour empty'
      };
    } else {
      return null;
    }
  };

  addExtraData(extradata = null) {
    const rgx = new RegExp(/^([a-zA-Z0-9\d ]{0,52})$/);
    const rgxValue = new RegExp(/^([a-zA-Z0-9\d ]{0,255})$/);
    const extraItem = this.formBuilder.group({
      title: [extradata?.title || '', [Validators.pattern(rgx)]],
      value: [extradata?.value || '', [Validators.pattern(rgxValue)]],
    });
    (this.contractForm.controls.extraData as FormArray).push(extraItem);
  }

  addSpeedCalculations(item = null) {
    const speedItem = this.formBuilder.group({
      regulationId: [item?.regulationId || '', [Validators.required]],
      initialSpeedFormula: [item?.initialSpeedFormula || '', [Validators.required]],
      finalSpeedFormula: [item?.finalSpeedFormula || '',]
    });
    (this.contractForm.controls.speedCalculations as FormArray).push(speedItem);
  }

  addformula(regulationId, idx, item) {
    const speedCalculation = this.contractForm.get('speedCalculations') as FormArray;
    if (regulationId === 74550) {
      speedCalculation.at(idx).get('initialSpeedFormula').setValue('round(v + 1)');
      speedCalculation.at(idx).get('finalSpeedFormula').setValue('round(v * 1.2)');
    } else if (regulationId === 74630) {
      speedCalculation.at(idx).get('initialSpeedFormula').setValue('round(v * 1.2 + 1)');
      speedCalculation.at(idx).get('finalSpeedFormula').setValue('round(v * 1.5)');
    } else if (regulationId === 74710) {
      speedCalculation.at(idx).get('initialSpeedFormula').setValue('round(v * 1.5 + 1)');
    }
  }

  addAitTemplates(item = null) {
    const templateItem = this.formBuilder.group({
      templateId: [item?.templateId || '',],
      regulationIds: [item?.regulationIds || '',]
    });
    (this.contractForm.controls.aitTemplates as FormArray).push(templateItem);
  }

  removeExtraData(idx) {
    (this.contractForm.controls.extraData as FormArray).removeAt(idx);
  }

  removeSpeedCalculations(idx) {
    (this.contractForm.controls.speedCalculations as FormArray).removeAt(idx);
  }

  removeAitTemplates(idx) {
    (this.contractForm.controls.aitTemplates as FormArray).removeAt(idx);
  }

  async checkContractCode(e, prop: 'internalCode' | 'code') {
    const code = e.target.value.toString();
    if (prop === 'internalCode') {
      return;
    }
    const response = await this.contractService.list({ [prop]: code });
    if (
      response.result.length > 0 &&
      response.result.filter(a => a.code === code).length > 0
    ) {
      this.alertService.show(new AlertItem('ContractSaveConflict', AlertType.danger));
      this.contractForm.get(prop).setValue('');
      this.contractForm.get(prop).setErrors({ invalid: true });
    }
  }

  getRegulation(regionId: any) {
    const regulationsIds = [74710, 74630, 74550];
    const params = {
      regionId,
      'id[in]': `[${regulationsIds}]`
    };

    this.regulationService.list(params).then(res => {
      this.regulations = res.result;
    });
  }

  checkNoZero(e, input) {
    if (Number(e.target.value) < 1) {
      this.contractForm.get(input).setValue(null);
    }
  }

  unfoldMoreLimit() {
    this.typeUnfoldLimit = this.typeUnfoldLimit === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document.getElementById(`limit`).scrollIntoView({ behavior: 'smooth' }),
      355);
  }

  unfoldMoreSpeed() {
    this.typeUnfoldSpeed = this.typeUnfoldSpeed === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document.getElementById(`speed`).scrollIntoView({ behavior: 'smooth' }),
      355);
  }

  unfoldMoreTemplate() {
    this.typeUnfoldTemplate = this.typeUnfoldTemplate === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document.getElementById(`template`).scrollIntoView({ behavior: 'smooth' }),
      355);
  }

  unfoldMoreAdditional() {
    this.typeUnfoldAdditional = this.typeUnfoldAdditional === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document.getElementById(`additional`).scrollIntoView({ behavior: 'smooth' }),
      355);
  }

  enabledChekcbox(event) {
    if (event) {
      this.checkBoxes = false;
      this.ecsModules.open = true;
    } else {
      this.contractForm.get('preProcess').setValue(false);
      this.contractForm.get('violations').setValue(false);
      this.contractForm.get('traffic').setValue(false);
      this.contractForm.get('status').setValue(false);
      this.contractForm.get('monitoring').setValue(false);
      this.contractForm.get('omnia').setValue(false);
      this.contractForm.get('initus').setValue(false);
      this.checkBoxes = true;
      this.ecsModules.open = false;
    }
  }

  checkregulation(item) {
    if (item.value.regulationId) {
      return false;
    }
    return true;
  }

  checkExtraData(item) {
    if (item.value.title) {
      return false;
    }
    return true;
  }

  checkCaracterLength(e, idx, input, size) {
    const extraData = this.contractForm.get('extraData') as FormArray;
    if (e.target.value.length > size) {
      extraData.at(idx).get(input).setValue(e.target.value.slice(0, -1));
    }
    if (input === 'title') {
      this.changeValidator(e, idx, extraData);
    }
  }

  changeValidator(e, idx, extraData) {
    if (e.target.value.length > 0) {
      extraData.at(idx).get('value').setValidators([Validators.required]);
      extraData.at(idx).get('value').updateValueAndValidity();
      extraData.at(idx).get('title').setValidators([Validators.required]);
      extraData.at(idx).get('title').updateValueAndValidity();
    } else if (e.target.value.length === 0) {
      extraData.at(idx).get('value').setValidators([]);
      extraData.at(idx).get('value').clearValidators();
      extraData.at(idx).get('value').updateValueAndValidity();
      extraData.at(idx).get('title').setValidators([]);
      extraData.at(idx).get('title').updateValueAndValidity();
    }
  }

  openOrCloseEcsModules() {
    this.ecsModules.open = !this.ecsModules.open;
  }

  openOrCloseLegacyModules() {
    this.legacyModules.open = !this.legacyModules.open;
  }

  enabledLegacyCheckbox(event) {
    if (event) {
      this.disabledLegacycheckBoxes = false;
      this.legacyModules.open = true;
    } else {
      this.disabledLegacycheckBoxes = true;
      this.legacyModules.open = false;
      for (const module of this.modulesBequest) {
        module.selected = false;
      }
    }
  }

  setModulesBequest(module) {
    module.selected = !module.selected;
  }

  async confirmSatus() {
    const modalTitle = 'Atenção';
    const modalMessage =
      `Ao alterar o status do contrato para Fechado ou Histórico, a recepção do Initus
      (recepção dos registros) será automaticamente inativada.`;
    return await this.modalService.show(new MessageModal(modalTitle, modalMessage, true));
  }

  public async onAllSubmited() {
    if (this.promise != null) {
      return this.promise;
    }

    if (
      this.contractStatus === ContractStatus.Closed ||
      this.contractStatus === ContractStatus.History
    ) {
      const confirm = await this.confirmSatus();
      if (!confirm) {
        return;
      }
    }

    const ownerCompanyId = this.contractForm.get('ownerCompanyId').value;
    const company = {
      id: null,
      name: null
    };
    const companyIds = this.contractForm.get('companyIds').value || [];
    const companies = [];
    for (const item of this.companies) {
      if (companyIds.includes(item.id)) {
        companies.push({ id: item.id, name: item.name });
      }
      if (ownerCompanyId === item.id) {
        company.id = item.id;
        company.name = item.name;
      }
    }
    const modules = [];
    for (const moduleItem of this.moduleArray) {
      if (this.contractForm.get(moduleItem).value === true) {
        modules.push(moduleItem);
      }
    }
    const timezone = 'America/Sao_Paulo';
    const speedCalculations = [];
    for (const itemSpeed of this.contractForm.get('speedCalculations').value) {
      itemSpeed.regulationId = Number(itemSpeed.regulationId);
      if (itemSpeed.regulationId) {
        speedCalculations.push(itemSpeed);
      }
    }
    const extraData = [];
    for (const itemExtraData of this.contractForm.get('extraData').value) {
      extraData.push(itemExtraData);
    }
    const aitTemplates = [];
    for (const itemTemplate of this.contractForm.get('aitTemplates').value) {
      if (itemTemplate.templateId) {
        aitTemplates.push(itemTemplate);
      }
    }
    const dtInit = this.contractForm.get('startsAt').value + ' ' + this.contractForm.get('startHour').value;
    const dtFinish = this.contractForm.get('endsAt').value + ' ' + this.contractForm.get('endHour').value;
    const dateContractInit = moment.tz(dtInit, timezone).utc().format();
    const dateContractFinish = moment.tz(dtFinish, timezone).utc().format();
    const modulesBequest = [];
    for (const module of this.modulesBequest) {
      if (module.selected) {
        modulesBequest.push(module.id);
      }
    }
    const data: any = {
      id: this.contract.id,
      code: this.contractForm.get('code').value,
      internalCode: this.contractForm.get('internalCode').value,
      name: this.contractForm.get('name').value,
      companyIds,
      companies,
      company,
      modules,
      regionId: this.contractForm.get('regionId').value,
      status: this.contractStatus,
      ownerCompanyId,
      timezone,
      enabledImportFile: false,
      limits: {
        equipments: Number(this.contractForm.get('equipments').value),
        spots: Number(this.contractForm.get('spots').value),
        lanes: Number(this.contractForm.get('lanes').value)
      },
      enabled: {
        omnia: this.contractForm.get('omnia').value,
        ecs: this.contractForm.get('ecs').value ? this.contractForm.get('ecs').value : false,
        initus: (
          this.contractStatus === ContractStatus.Closed ||
            this.contractStatus === ContractStatus.History
            ? false : this.contractForm.get('initus').value
        ),
        initusTraffic: this.contractForm.get('initusTraffic').value,
        bequest: this.contractForm.get('bequest').value
      },
      speedCalculations,
      extraData,
      aitTemplates,
      startsAt: dateContractInit,
      endsAt: dateContractFinish,
      modulesBequest,
      bequestUrl: this.contractForm.get('bequestUrl').value,
      equipmentModelIds: this.contract.equipmentModelIds || []
    };
    const contract = Contract.create(data);
    try {
      if (this.contract.id != null) {
        this.promise = this.contractService.update(contract);
      } else {
        this.promise = this.contractService.create(contract);
      }
      this.promise.then(async (res) => {
        this.alertService.show(new AlertItem('ContractSaved', AlertType.success));
        await this.userService.list({ id: this.user.id }).then(resUser => {
          const updateUser = resUser.result[0];
          this.storageService.set(StorageKey.currentUser, updateUser);
        });
        this.emitValid(res);
        return res;
      }).catch(error => {
        if (error.status === 409) {
          this.alertService.show(new AlertItem('ContractSaveConflict', AlertType.danger));
        } else {
          this.alertService.show(new AlertItem('ContractSaveError', AlertType.danger));
          throw error;
        }
      });
    } catch (err) {
      console.error(err);
    }
    let userGroups = null;
    if (this.user.superUser === false && !this.contract.id) {
      this.userGroupService.getAll(null, true).then(response => {
        userGroups = response;
        if (response) {
          updateLocalStorage(this.user, this.storageService, response);
        }
        return response;
      }).finally(() => {
        setTimeout(() => {
          updateCurrentContracts(this.contractForm.get('code').value, this.storageService, userGroups);
        }, 3000);
      });
    }
    return this.promise;
  }
};
